import { HelpCircle } from 'iconoir-react'

const StyledInput = ({
    label = '',
    id = '',
    type = 'text',
    required = false,
    helpText = '',
    disabled = false,
    ...props
}) => {
    return (
        <div>
            <label
                htmlFor={id}
                className="block text-sm font-medium text-gray-700"
            >
                {label} {required && <span className="text-red-500">*</span>}
                {helpText && (
                    <HelpCircle
                        className="ml-1 inline-block text-gray-400"
                        size={16}
                    />
                )}
            </label>
            <input
                type={type}
                id={id}
                name={id}
                className={`mt-1 block w-full rounded-md border px-3 py-2 shadow-sm hover:border-secondary-color focus:outline-none ${
                    disabled
                        ? 'cursor-not-allowed border-gray-300 bg-gray-100 text-gray-500'
                        : 'border-gray-300 focus:border-secondary-color focus:ring-secondary-color'
                }`}
                required={required}
                disabled={disabled}
                {...props}
            />
        </div>
    )
}

export default StyledInput
